const LOCALIZATION = 'localization';

export { LOCALIZATION};
